/* eslint-disable */

import {
  sameAs,
  helpers
} from "vuelidate/lib/validators";

import store from '@/store'

export const checked = sameAs(() => true);

export const cardCVC = cvc => {
  let valid = require("card-validator");
  let cvcValidation = valid.cvv(cvc);
  let response = false;
  if (!cvcValidation.isValid) {
    response = false;
  } else {
    response = true;
  }
  return response;
};

export const masks = (masks) => (value) => {
  let response = false;
  masks.forEach(mask => {
    if (mask.length == value.length) {
      response = true;
    }
  });
  return response;
};


export const customRequired = (child) => (value) => {
  return (eval('value.' + child) !== undefined);
}

export const brazilianDocument = (value) => {

  if (value.length == 18) {
    return cnpj(value);
  } else if (value.length == 14) {
    return cpf(value);
  } else {
    return false;
  }

  function cpf(cpf) {
    if (cpf.length != "") {
      var exp = /\.|\-/g;
      cpf = cpf.toString().replace(exp, "");
      if (((cpf.length == 11) && (cpf == "11111111111") || (cpf == "22222222222") || (cpf == "33333333333") || (cpf == "44444444444") || (cpf == "55555555555") || (cpf == "66666666666") || (cpf == "77777777777") || (cpf == "88888888888") || (cpf == "99999999999") || (cpf == "00000000000")))
        return false;
      var add = 0;
      for (i = 0; i < 9; i++)
        add += parseInt(cpf.charAt(i)) * (10 - i);
      var rev = 11 - (add % 11);
      if (rev == 10 || rev == 11)
        rev = 0;
      if (rev != parseInt(cpf.charAt(9)))
        return false;
      add = 0;
      for (var i = 0; i < 10; i++)
        add += parseInt(cpf.charAt(i)) * (11 - i);
      rev = 11 - (add % 11);
      if (rev == 10 || rev == 11)
        rev = 0;
      if (rev != parseInt(cpf.charAt(10)))
        return false;

      return true;
    }
    return false;
  }

  function cnpj(cnpj) {

    if (cnpj.length != "") {

      var expv = /([a-zA-Z])/g;

      if (expv.test(cnpj)) return false;

      var valida = new Array(6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2);
      var dig1 = new Number;
      var dig2 = new Number;

      var exp = /\.|\-|\//g
      cnpj = cnpj.toString().replace(exp, "");

      // Elimina CNPJs invalidos conhecidos
      if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999")
        return false;


      var digito = +(cnpj.charAt(12) + cnpj.charAt(13));

      for (var i = 0; i < valida.length; i++) {
        dig1 += (i > 0 ? (cnpj.charAt(i - 1) * valida[i]) : 0);
        dig2 += cnpj.charAt(i) * valida[i];
      }
      dig1 = (((dig1 % 11) < 2) ? 0 : (11 - (dig1 % 11)));
      dig2 = (((dig2 % 11) < 2) ? 0 : (11 - (dig2 % 11)));

      if (((dig1 * 10) + dig2) != digito) {
        return false;
      }
      return true;
    }
    return false;

  }
}


export const cardExpiringDate = date => {
  let valid = require("card-validator");
  let response = false;
  if (date.length != 5) {
    // response = "Incomplete";
    response = false;
  } else {
    let month = date.substring(0, 2);
    let year = date.substring(3);


    let monthValidation = valid.expirationMonth(month);
    let yearValidation = valid.expirationYear(year);

    if (!yearValidation.isValid) {
      // response = "(Invalid Year!)";
      response = false;
    } else {
      if (!monthValidation.isValid) {
        // response = "(Invalid Month!)";
        response = false;
      } else {
        let today = new Date();
        if (
          today
          .getFullYear()
          .toString()
          .substr(-2) == year
        ) {
          if (today.getMonth().toString() + 1 + 3 > month) {
            // response = "Invalid Date";
            response = false;
          } else {
            // response = "Valid Date at Same Year";
            response = true;
          }
        } else {
          // response = "Valid Date";
          response = true;
        }
      }
    }
  }

  return response;
};
export const cardNumber = value => {
  let valid = require("card-validator");
  let numberValidation = valid.number(value);
  let response = false;
  if (!numberValidation.isPotentiallyValid) {
    response = false;
  } else if (numberValidation.card) {
    response = numberValidation.card.type;
  }
  store.commit('signup/SET_CARD_TYPE', response);
  return numberValidation.isValid;
};

export const emailIsUsed = async value => {
  if (value != undefined && value != "") {    
    await store.dispatch("signup/checkUserExists", { 
      userMail: value
    })
    
    return !store.state.signup.userExists
      
  }
  return true
}

/* eslint-enable */